import styled from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const ContentCtn = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const FullWidthCtn = styled.div`
  flex: 0 0 100%;
`;

export const ReactiveListCtn = styled.div`
  flex: 0 0 43%;

  ${Media.Below.desktopLarge`
    flex: 1 0 100%;
  `}

  ${Media.Below.tablet`
    flex: 1 0 100%;
  `}
`;

export const PlannedListCtn = styled.div`
  flex: 0 0 43%;

  ${Media.Below.desktopLarge`
    flex: 1 0 100%;
    padding-top: 80px;
  `}

  ${Media.Below.tablet`
    flex: 1 0 100%;
  `}
`;

export const HeadingCtn = styled.div`
  display: flex;
  justify-content: space-between;

  > span {
    font-size: 30px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 24px;
    `}

    ${Media.Below.tablet`
      font-size: 22px;
    `}

    ${Media.Below.mobileLarge`
      font-size: 20px;
    `}
  }

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}
`;

export const LinkToPage = styled.div`
  font-size: 15px;
  font-weight: bold;
  align-self: center;
  width: auto;
  white-space: nowrap;
  color: ${THEME.colors.primaryFontColor};
  border-bottom: ${THEME.colors.primaryFontColor} 1px solid;

  :hover {
    color: ${THEME.colors.primaryFontColor};
    text-decoration: none;
  }

  ${Media.Below.tablet`
    align-self: center;
    font-size: 12px;
  `}

  ${Media.Below.mobileLarge`
    align-self: end;
  `}
`;

export const PageCtn = styled.div`
  width: 90%;
  padding: 4vw 0 0 6vw;

  ${Media.Below.tablet`
    width: 100%;
    padding: 55px 30px 0;
  `}

  ${Media.Below.mobileLarge`
    padding: 50px 15px 0;
  `}
`;

export const PageHeaderImgCtn = styled.div`
  height: 100px;

  ${Media.Below.desktop`
    height: 65px;
  `}

  ${Media.Below.mobileLarge`
    display: flex;
    justify-content: center;
    height: 70px;
  `}

  > img {
    height: 100%;
  }
`;

export const PageHeaderText = styled.span`
  font-size: 18px;

  ${Media.Below.desktop`
    font-size: 15px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 15px;
    text-align: center;
  `}
`;
